import { apiRequest } from './client';

/** FAQ support bot (SRS #19). */

const TOKEN_KEY = 'policyora_token';
const opts = (extra: RequestInit = {}): RequestInit => {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
};

export interface FaqSuggestion { id: number; question: string }
export interface FaqAnswer {
  conversation_id: number;
  kind: 'faq' | 'suggest' | 'none';
  confidence: number;
  faq_id: number | null;
  question?: string;
  answer: string;
  link?: string | null;
  category?: string;
  suggestions: FaqSuggestion[];
  can_escalate: boolean;
}
export interface FaqEntryPublic { id: number; question: string; answer: string; category: string; link?: string | null }
export interface FaqEntry extends FaqEntryPublic {
  aliases: string[]; keywords: string[]; audience: 'all' | 'user' | 'admin'; published: boolean;
  views: number; helpful: number; unhelpful: number; has_embedding: boolean; updated_by?: string | null; updated_at?: string | null;
}
export interface FaqInsights {
  days: number; questions: number; answered: number; escalated: number; answer_rate: number | null; helpful_rate: number | null;
  unanswered: { question: string; count: number; last_asked: string | null; kind: string }[];
  weak_entries: FaqEntry[];
}

export const sessionKey = (): string => {
  try {
    let k = sessionStorage.getItem('faq_session');
    if (!k) { k = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('faq_session', k); }
    return k;
  } catch { return 'anon'; }
};

export const listFaq = () => apiRequest<{ categories: string[]; entries: FaqEntryPublic[] }>('/api/v1/faq/entries', opts());
export const askFaq = (question: string) => apiRequest<FaqAnswer>('/api/v1/faq/ask', opts({ method: 'POST', body: JSON.stringify({ question, session_key: sessionKey() }) }));
export const openFaqSuggestion = (conversationId: number, faqId: number) => apiRequest<FaqAnswer>(`/api/v1/faq/${conversationId}/open/${faqId}`, opts({ method: 'POST' }));
export const rateFaq = (conversationId: number, helpful: boolean) => apiRequest<{ conversation_id: number; helpful: boolean; can_escalate: boolean }>(`/api/v1/faq/${conversationId}/rate`, opts({ method: 'POST', body: JSON.stringify({ helpful }) }));
export const escalateFaq = (conversationId: number, message = '') => apiRequest<{ ticket_id: number; already: boolean }>(`/api/v1/faq/${conversationId}/escalate`, opts({ method: 'POST', body: JSON.stringify({ message }) }));

// admin
export const adminListFaq = () => apiRequest<{ categories: string[]; entries: FaqEntry[] }>('/api/v1/admin/faq', opts());
export const adminCreateFaq = (p: Partial<FaqEntry>) => apiRequest<FaqEntry>('/api/v1/admin/faq', opts({ method: 'POST', body: JSON.stringify(p) }));
export const adminUpdateFaq = (id: number, p: Partial<FaqEntry>) => apiRequest<FaqEntry>(`/api/v1/admin/faq/${id}`, opts({ method: 'PUT', body: JSON.stringify(p) }));
export const adminDeleteFaq = (id: number) => apiRequest<{ deleted: number }>(`/api/v1/admin/faq/${id}`, opts({ method: 'DELETE' }));
export const adminFaqInsights = (days = 30) => apiRequest<FaqInsights>(`/api/v1/admin/faq/insights?days=${days}`, opts());
export const adminTestFaq = (question: string) => apiRequest<{ matches: { id: number; question: string; score: number; would: string }[]; thresholds: { answer: number; suggest: number } }>('/api/v1/admin/faq/test', opts({ method: 'POST', body: JSON.stringify({ question }) }));
